/* KIRA PDP ETA range v1: actualiza SOLO el texto de llegada en tarjeta KIRA.
   Regla comercial: 8–13 días hábiles de entrega total, lunes a sábado,
   excluyendo domingos y los descansos federales obligatorios (LFT art. 74).
   No cambia el contador, Sternify, Globo, precios ni el carrito.
   El cómputo inicia el siguiente día hábil después del pedido.
*/
(() => {
  'use strict';
  if (window.__kiraEtaRangeV1) return;
  window.__kiraEtaRangeV1 = true;

  const ETA_SELECTOR = '.kira-season__eta';
  const MONTHS = ['enero','febrero','marzo','abril','mayo','junio',
    'julio','agosto','septiembre','octubre','noviembre','diciembre'];
  const dayFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Mexico_City', year: 'numeric', month: 'numeric', day: 'numeric'
  });
  const dateParts = date => {
    const p = Object.fromEntries(dayFormatter.formatToParts(date)
      .filter(x => x.type !== 'literal').map(x => [x.type, Number(x.value)]));
    return new Date(Date.UTC(p.year, p.month - 1, p.day, 12));
  };
  const isRestDay = d => {
    const month = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const weekday = d.getUTCDay();
    const year = d.getUTCFullYear();
    if (weekday === 0) return true; // Domingos
    return (month === 1 && day === 1) ||
      (month === 2 && weekday === 1 && day <= 7) ||
      (month === 3 && weekday === 1 && day >= 15 && day <= 21) ||
      (month === 5 && day === 1) ||
      (month === 9 && day === 16) ||
      (month === 11 && weekday === 1 && day >= 15 && day <= 21) ||
      (month === 12 && day === 25) ||
      (month === 10 && day === 1 && year >= 2024 && (year - 2024) % 6 === 0);
    // Días electorales extraordinarios se ajustan manualmente si aplica.
  };
  const afterBusinessDays = (today, numberOfDays) => {
    const d = new Date(today.getTime());
    let count = 0;
    while (count < numberOfDays) {
      d.setUTCDate(d.getUTCDate() + 1);
      if (!isRestDay(d)) count++;
    }
    return d;
  };
  const formatRange = (a, b) => {
    const d1 = a.getUTCDate(), d2 = b.getUTCDate();
    const m1 = a.getUTCMonth(), m2 = b.getUTCMonth();
    const y1 = a.getUTCFullYear(), y2 = b.getUTCFullYear();
    if (m1 === m2 && y1 === y2) return d1 + '–' + d2 + ' de ' + MONTHS[m1];
    if (y1 === y2) return d1 + ' de ' + MONTHS[m1] + '–' + d2 + ' de ' + MONTHS[m2];
    return d1 + ' de ' + MONTHS[m1] + ' de ' + y1 +
      '–' + d2 + ' de ' + MONTHS[m2] + ' de ' + y2;
  };

  let target = null;
  let etaObserver = null;
  const refresh = () => {
    const node = document.querySelector(ETA_SELECTOR);
    if (!node) {
      if (etaObserver) { etaObserver.disconnect(); etaObserver = null; target = null; }
      return;
    }
    if (node !== target) {
      if (etaObserver) etaObserver.disconnect();
      target = node;
      etaObserver = new MutationObserver(refresh);
      etaObserver.observe(node, { childList: true, subtree: true, characterData: true });
    }
    const today = dateParts(new Date());
    const from = afterBusinessDays(today, 8);
    const to = afterBusinessDays(today, 13);
    const wanted = 'Llegada estimada: ' + formatRange(from, to);
    if (node.textContent.trim() !== wanted) {
      const strong = document.createElement('strong');
      strong.textContent = wanted;
      node.replaceChildren(strong);
    }
  };

  const start = () => {
    refresh();
    // Espera al módulo si se monta después de que el DOM esté listo.
    const mountObserver = new MutationObserver(() => {
      if (document.querySelector(ETA_SELECTOR)) {
        refresh();
        mountObserver.disconnect();
      }
    });
    if (!document.querySelector(ETA_SELECTOR)) {
      mountObserver.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => mountObserver.disconnect(), 20000);
    }
    window.setInterval(refresh, 30000); // Revalida al cambiar de día o si se reinyecta la tarjeta.
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) refresh();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();